 const ActionsOptions = {
   filter: false,
   sort: false,
   download: false,
   print: false,
   viewColumns:false,
 }

 export default ActionsOptions